<img style="{{style}}" [src]="src" alt="">
